import actionTypes from "./actionTypes";

const initialState = {
    isLoaded: true,
    message: null,
    warning: null,
};

export default function apps(state = initialState, action) {
    if (action.type === actionTypes.LOAD_APPS) {
        const isLoaded = action.payload;
        return {
            ...state,
            isLoaded: isLoaded
        }
    } else {
        return state;
    }
}
